import React, { useState, useEffect } from "react";
import {
  FaUser, FaPhone, FaEnvelope, FaShieldAlt, FaCheckCircle, FaUserCheck, FaUserTimes, FaBuilding, FaMapMarkerAlt, FaFileInvoice, FaImage, FaIdCard, FaFilePdf, FaSearch, FaPlus, FaTimes
} from "react-icons/fa";
import { MdLocationCity } from "react-icons/md";
import { FaHouse } from "react-icons/fa6";
import { GrUserManager } from "react-icons/gr";
import { MdAccountBalance } from "react-icons/md";
import { MdOutlineAccountCircle } from "react-icons/md";
import { BsBank } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { CgDanger } from "react-icons/cg";
import axios from 'axios'
import toast from "react-hot-toast";
import { MdDeleteForever } from "react-icons/md";
import { PiKeyReturnFill } from "react-icons/pi";

function CustomerSphere({ token }) {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [customerSphere, setCustomerSphere] = useState([]);
  const [showMachineModal, setShowMachineModal] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [showCancelRefund, setShowCancelRefund] = useState(false);
  const [remark, setRemark] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDelete, setSelectedDelete] = useState(null);
  const [returnRequests, setReturnRequests] = useState({});

  const [showExchangeModal, setShowExchangeModal] = useState(false);
  const [showCancelExchange, setShowCancelExchange] = useState(false);
  const [selectedExchange, setSelectedExchange] = useState(null);
  const [exchangeRemark, setExchangeRemark] = useState("");

  const [showReturnModal, setShowReturnModal] = useState(false);
  const [selectedReturn, setSelectedReturn] = useState(null);
  const [showCancelReturn, setShowCancelReturn] = useState(false);
  const [returnRemark, setReturnRemark] = useState("");
  const [showReturnDetailModal, setShowReturnDetailModal] = useState(false);
  const [selectedReturnDetail, setSelectedReturnDetail] = useState(null);

const [showReturnOtp, setShowReturnOtp] = useState(false);
const [returnOtp, setReturnOtp] = useState("");

const [showExchangeOtp, setShowExchangeOtp] = useState(false);
const [exchangeOtp, setExchangeOtp] = useState("");
const [exchangeOtpError, setExchangeOtpError] = useState("");
 const [statusFilter, setStatusFilter] = useState("All");

  const fetchCutEnquiry = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-customer-part-enquiry",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;


      setCustomerSphere(result);
    } catch (error) {
      console.log(error);
    }
  };



  useEffect(() => {
    fetchCutEnquiry();

  }, []);


  const fetchReturn = async (enqId) => {
    try {
      const res = await axios.get(
        `https://api.krimotion.in/get-retex-request/${enqId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("API Response:", res.data);
      return res.data;

    } catch (error) {
      console.log(error);
      return null;
    }
  };




  const handleCloseEnquiry = async () => {

    try {
      const res = await axios.put(
        `https://api.krimotion.in/close-sphere-enquiry/${selectedData.id}`,
        {
          enquire_status: "Closed",
          rejected_on: new Date().toISOString().slice(0, 19).replace("T", " "),
          otp: otp,

        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      toast.success("Enquiry closed successfully.");

      setShowCloseModal(false);
      setSelectedData(null);
      fetchCutEnquiry();
    } catch (err) {
      console.error(err);

      if (err.response?.status === 400) {
        setOtpError(err.response.data.message);
        // setShowCloseModal(false);
      } else {
        toast.error("Failed to close enquiry.");
        setShowCloseModal(false);
      }
    }
  };


  const handleRefund = async () => {
    try {
      const res = await axios.put(
        `https://api.krimotion.in/update-sphere-enq-refund/${selectedDriver.id}`,
        {
          cust_id: selectedDriver.cust_id,
          enquire_status: "Refund Completed",
          refund_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      toast.success("Refund completed successfully.");

      setShowRefundModal(false);
      setSelectedDriver(null);
      fetchCutEnquiry();
    } catch (err) {
      console.error(err);
      toast.error("Failed to process refund.");
    }
  };


  const handleCancelRefund = async () => {
    if (!remark.trim()) {
      toast.warning("Please enter remark.");
      return;
    }

    try {
      const res = await axios.put(
        `https://api.krimotion.in/cancel-sphere-enq-refund/${selectedDriver.id}`,
        {
          cust_id: selectedDriver.cust_id,
          enquire_status: "Refund Cancelled",
          rejected_on: new Date().toISOString().slice(0, 19).replace("T", " "),
          rej_remark: remark,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      toast.success("Refund cancelled successfully.");

      setShowRefundModal(false);
      setSelectedDriver(null);
      fetchCutEnquiry();
    } catch (err) {
      console.error(err);
      toast.error("Failed to process refund.");
    }
  };

  const handleDeleteEnquiry = async () => {
    try {
      const res = await axios.delete(
        `https://api.krimotion.in/delete-part-enquiry/${selectedDelete.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(res.data.message);

      setShowDeleteModal(false);
      setSelectedDelete(null);

      fetchCutEnquiry();
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  // const filteredData = Array.isArray(customerSphere)
  //   ? customerSphere.filter(itm =>
  //     Object.values(itm).some(val =>
  //       String(val).toLowerCase().includes(searchTerm.toLowerCase())
        
  //     )
  //   )
  //   : [];

  const filteredData = Array.isArray(customerSphere)
  ? customerSphere.filter((itm) => {
      const matchesSearch = Object.values(itm).some((val) =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      );

      const matchesStatus =
        statusFilter === "All"
          ? true
          : itm.enquire_status === statusFilter;

      return matchesSearch && matchesStatus;
    })
  : [];

  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  };


  const items = selectedMachine?.items
    ? JSON.parse(selectedMachine.items)
    : [];

  //   useEffect(() => {
  //   const loadReturnRequests = async () => {
  //     const data = {};


  //     for (const dealer of filteredData) {
  //       const result = await fetchReturn(dealer.id);


  //     if (result && result.length > 0) {
  //   data[dealer.id] = result[0];
  // }

  //     }

  //     setReturnRequests(data);
  //   };

  //   if (filteredData.length) {
  //     loadReturnRequests();
  //   }
  // }, [filteredData]);
  useEffect(() => {

    if (customerSphere.length) {
      loadReturnRequests();
    }

  }, [customerSphere]);


  const handleExchangeComplete = async () => {
    try {

      await axios.put(
        `https://api.krimotion.in/exchange-complete/${selectedExchange.request.id}`,
        {
          cust_id: selectedExchange?.dealer?.cust_id,
          status: "Exchange Completed",
          refund_date: new Date().toISOString().slice(0, 19).replace("T", " "),

        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );


      setShowExchangeModal(false);

      // refresh status
      loadReturnRequests();
      toast.success("Exchnage Completed Successfully!");

    } catch (error) {
      console.log(error);
      toast.error("Fail to complete exchnage!")
    }
  };


  const handleExchangeCancel = async () => {

    if (!exchangeRemark.trim()) {
      toast.warning("Please enter remark");
      return;
    }

    try {

      await axios.put(
        `https://api.krimotion.in/exchange-cancel/${selectedExchange.request.id}`,
        {
          refund_rem: exchangeRemark,
          cust_id: selectedExchange?.dealer?.cust_id,
          status: "Exchange Cancelled",
          refund_date: new Date().toISOString().slice(0, 19).replace("T", " "),


        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );


      setShowExchangeModal(false);
      setShowCancelExchange(false);
      setExchangeRemark("");

      loadReturnRequests();

    } catch (error) {
      console.log(error);
    }

  };


  const handleReturnComplete = async () => {
    try {

      await axios.put(
        `https://api.krimotion.in/return-complete/${selectedReturn.request.id}`,
        {
          cust_id: selectedReturn?.dealer?.cust_id,
          status: "Return Completed",
          refund_date: new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ")
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );


      setShowReturnModal(false);

      loadReturnRequests();
      toast.success("Return Completed Successfully")

    } catch (error) {
      console.log(error);
      toast.error('Fail to complete reutrn ')
      setShowReturnModal(false);
    }
  };

  const handleReturnCancel = async () => {

    if (!returnRemark.trim()) {
      toast.warning("Please enter remark");
      return;
    }


    try {

      await axios.put(
        `https://api.krimotion.in/return-cancel/${selectedReturn.request.id}`,
        {
          refund_rem: returnRemark,
          cust_id: selectedReturn?.dealer?.cust_id,
          status: "Return Cancelled",
          refund_date: new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ")
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );


      setShowReturnModal(false);
      setReturnRemark("");

      loadReturnRequests();
      toast.success("Return Cancelled Successfully!")

    } catch (error) {
      console.log(error);
      toast.error("Fail to cancelled return");
      setShowReturnModal(false);
    }

  };



  const loadReturnRequests = async () => {
    const data = {};

    for (const dealer of filteredData) {
      const result = await fetchReturn(dealer.id);

      if (result && result.length > 0) {
        data[dealer.id] = result[0];
      }
    }

    setReturnRequests(data);
  };

const returnAmount = selectedReturn?.request?.ret_items
  ? JSON.parse(selectedReturn.request.ret_items).reduce(
      (total, item) => total + Number(item.final_price || 0),
      0
    )
  : 0;


  const verifyReturnOtp = () => {

  const actualOtp = selectedReturn?.request?.d_otp;

  if (returnOtp === actualOtp) {

    setOtpError("");
    setShowReturnOtp(false);
    setReturnOtp("");

    handleReturnComplete();

  } else {

    setOtpError("Invalid OTP. Please enter correct OTP.");

  }

};


const verifyExchangeOtp = () => {

  const actualOtp = selectedExchange?.request?.d_otp;

  if (exchangeOtp === actualOtp) {

    setExchangeOtpError("");
    setShowExchangeOtp(false);
    setExchangeOtp("");

    handleExchangeComplete();

  } else {

    setExchangeOtpError("Invalid OTP. Please enter correct OTP.");

  }

};

  const statusOptions = [
  "All",
  ...new Set(
    Array.isArray(customerSphere)
      ? customerSphere.map((item) => item.enquire_status)
      : []
  ),
];


  return (
    <div className="container py-4">

      <div className="border-0  mb-3 px-2 py-2  ">

        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div className="d-flex align-items-center">
            <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
              Customer Spare Parts Enquiry
            </h4>
          </div>

          {/* CENTER SEARCH */}
          <div style={{ flex: 1, maxWidth: "250px" }}>
            <div
              className="d-flex align-items-center rounded-pill overflow-hidden"
              style={{
                border: "1px solid var(--green)",
                height: "34px",
                paddingLeft: "8px",
                paddingRight: "8px",
                backgroundColor: 'white'
              }}
            >
              {/* ICON */}
              <FaSearch
                style={{
                  color: "var(--green)",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center"
                }}
              />

              {/* INPUT */}
              <input
                type="text"
                className="form-control border-0 shadow-none"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  fontSize: "14px",
                  height: "32px",
                  marginLeft: "6px",
                  lineHeight: "32px"
                }}
              />
            </div>
          </div>



        </div>
      </div>


  
      {!showForm && (

     <>
         <div className="d-flex justify-content-end align-items-center mb-3">
      <div style={{ width: "200px" }}>
        <select
          className="form-select shadow-sm"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          {statusOptions.map((status, index) => (
            <option key={index} value={status}>
              {status}
            </option>
          ))}
        </select>
      </div>
    </div>


        <div className="container-fluid mt-4">
          <div className="row g-4">

            {filteredData.length > 0 ? (
              filteredData.map((dealer, index) => {

                const request = returnRequests[dealer.id];
                return (

                  <div className="col-xl-4 col-lg-6 col-md-6" key={index}>

                    <div className="inventory-card d-flex flex-column h-100">

                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-start">

                        <div>
                          <h5 className="inventory-title mb-1">
                            {dealer.cust_name}
                          </h5>

                          <small className="text-muted">
                            {dealer.cust_mobile}
                          </small>
                        </div>

                        <span
                          className={`badge ${dealer.enquire_status === "Closed"
                              ? "bg-success"
                              : dealer.enquire_status === "Refund Request"
                                ? "bg-warning text-dark"
                                : dealer.enquire_status === "Refund Completed"
                                  ? "bg-success"
                                  : dealer.enquire_status === "Refund Cancelled"
                                    ? "bg-danger"
                                    : "bg-primary"
                            }`}
                        >
                          {dealer.enquire_status}
                        </span>

                      </div>

                      <hr />

                      {/* Details */}

                      <div className="inventory-row">
                        <span className="inventory-label">
                          Customer
                        </span>

                        <span>{dealer.cust_name}</span>
                      </div>

                      <div className="inventory-row">
                        <span className="inventory-label">
                          Mobile
                        </span>

                        <span>{dealer.cust_mobile}</span>
                      </div>

                      <div className="inventory-row">
                        <span className="inventory-label">
                          Added On
                        </span>

                        <span>{formatDate(dealer.enquire_on)}</span>
                      </div>




 
                      <div className=" d-flex flex-wrap gap-2 align-items-center">
                      <div className="inventory-row gap-2">
                          {request ? (
                            request.status === "Exchange Initiated" ? (
                              <button
                                className="btn-action btn-warning-custom"
                                onClick={() => {
                                  setSelectedExchange({
                                    dealer,
                                    request
                                  });
                                  setShowExchangeModal(true);
                                }}
                              >
                                Exchange Initiated
                              </button>
                            ) : request.status === "Exchange Completed" ? (
                              <button className="btn-action btn-success-custom">
                                Exchange Completed
                              </button>
                            ) : request.status === "Exchange Cancelled" ? (
                              <button className="btn-action btn-danger-custom">
                                Exchange Cancelled
                              </button>
                            ) : request.status === "Return Initiated" ? (
                              <button
                                className="btn-action btn-warning-custom"
                                onClick={() => {
                                  setSelectedReturn({
                                    dealer,
                                    request
                                  });
                                  setShowReturnModal(true);
                                }}
                              >
                                Return Initiated
                              </button>
                            ) : request.status === "Return Completed" ? (
                              <button className="btn-action btn-success-custom">
                                Return Completed
                              </button>
                            ) : request.status === "Return Cancelled" ? (
                              <button className="btn-action btn-danger-custom">
                                Return Cancelled
                              </button>
                            ) : null
                          ) : (
                            null
                          )}
                    
                         {request && (
                          <button
                            className="btn-action btn-primary-custom"
                            onClick={() => {
                              setSelectedReturnDetail({
                                dealer,
                                request
                              });
                              setShowReturnDetailModal(true);
                            }}
                          >
                            View Return Detail
                          </button>
                        )}
                        
                      </div>

 </div>
                      {/* Action Buttons */}

                      <div className="mt-auto pt-3">

                        <div className="d-flex flex-wrap gap-2">

                       

                          <button
                            className="btn-action btn-primary-custom"
                            onClick={() => {
                              setSelectedMachine(dealer);
                              setShowMachineModal(true);
                            }}
                          >
                            View
                          </button>

                          {/* Closed Badge */}

                          {dealer.enquire_status === "Closed" && (
                            <span className="status-badge status-success">
                              Closed
                            </span>
                          )}

                          {/* Enquiry */}

                          {dealer.enquire_status !== "Refund Request" &&
                            dealer.enquire_status !== "Refund Completed" &&
                            dealer.enquire_status !== "Refund Cancelled" &&
                            dealer.enquire_status !== "Closed" &&
                            dealer.enquire_status !== "Cancelled" && (

                              <button
                                className="btn-action btn-warning-custom"
                                onClick={() =>
                                  navigate("/admin/dealer-quotation", {
                                    state: {
                                      dealer,
                                    },
                                  })
                                }
                              >
                                Enquiry
                              </button>
                            )}

                          {/* Refund */}

                          {(dealer.enquire_status === "Refund Request" ||
                            dealer.enquire_status === "Refund Completed" ||
                            dealer.enquire_status === "Refund Cancelled") && (

                              <button
                                className={`btn-action ${dealer.enquire_status === "Refund Completed"
                                    ? "btn-success-custom"
                                    : dealer.enquire_status === "Refund Cancelled"
                                      ? "btn-danger-custom"
                                      : "btn-warning-custom"
                                  }`}
                                onClick={() => {
                                  setSelectedDriver(dealer);
                                  setShowRefundModal(true);
                                }}
                                disabled={
                                  dealer.enquire_status === "Refund Completed" ||
                                  dealer.enquire_status === "Refund Cancelled"
                                }
                              >
                                {dealer.enquire_status === "Refund Completed"
                                  ? "Refunded"
                                  : dealer.enquire_status === "Refund Cancelled"
                                    ? "Refund Rejected"
                                    : "Refund"}
                              </button>
                            )}

                          {/* Close */}

                          {(dealer.enquire_status === "Converted" ||
                            dealer.enquire_status === "Refund Cancelled") && (

                              <button
                                className="btn-action btn-danger-custom"
                                onClick={() => {
                                  setSelectedData(dealer);
                                  setShowCloseModal(true);
                                }}
                              >
                                Closed
                              </button>
                            )}

                      

                          <button
                            className="btn-action btn-secondary-custom"
                            onClick={() => {
                              setSelectedDelete(dealer);
                              setShowDeleteModal(true);
                            }}
                          >
                            Delete
                          </button>

                                                <button
  className="btn-action btn-success-custom"
  onClick={() =>
    navigate("/admin/chat-history", {
      state: {
        dealer: dealer,
        enq_type:"Spares", 
      },
    })
  }
>
  View Chat
</button>

                        </div>

                      </div>

                    </div>

                  </div>

                )
              }


              )
            ) : (
              <div className="col-12 text-center py-5">
                <h5>No Data Found</h5>
              </div>
            )}

          </div>
        </div>
        </>
      )}

      {showMachineModal && (
        <div
          className="modal d-block"
          style={{
            background: "rgba(0,0,0,.55)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
            <div
              className="modal-content border-0 shadow-lg"
              style={{ borderRadius: "18px" }}
            >
              {/* Header */}
              <div className="modal-header bg-primary text-white">
                <div>
                  <h4 className="mb-0">Enquiry Details</h4>
                  <small>Customer & Payment Information</small>
                </div>

                <button
                  className="btn btn-light btn-sm"
                  onClick={() => {
                    setShowMachineModal(false);
                    setSelectedMachine(null);
                  }}
                >
                  ✕
                </button>
              </div>

              <div className="modal-body">



                {/* Item Details */}

                <div className="card mb-4 shadow-sm">
                  <div className="card-header bg-success text-white">
                    <h5 className="mb-0">Items Details</h5>
                  </div>

                  <div className="card-body">

                    {items.length > 0 ? (
                      items.map((item, index) => (
                        <div className="card mb-3 border" key={index}>
                          <div className="card-body">

                            <div className="row align-items-center">

                              <div className="col-md-3 text-center">

                                <img
                                  src={`https://api.krimotion.in/uploads/${item.imgs}`}
                                  alt={item.name}
                                  className="img-fluid rounded border"
                                  style={{
                                    maxHeight: "150px",
                                    objectFit: "cover",
                                  }}
                                />

                              </div>

                              <div className="col-md-9">

                                <div className="row">

                                  <div className="col-md-6">
                                    <label className="text-muted">
                                      Item Name
                                    </label>
                                    <h6>{item.name}</h6>
                                  </div>

                                  <div className="col-md-3">
                                    <label className="text-muted">
                                      Qty
                                    </label>
                                    <h6>{item.qty}</h6>
                                  </div>

                                  <div className="col-md-3">
                                    <label className="text-muted">
                                      Sub Category
                                    </label>
                                    <h6>{item.sub_category || "-"}</h6>
                                  </div>

                                  <div className="col-md-6">
                                    <label className="text-muted">
                                      MRP
                                    </label>
                                    <h6>₹ {item.mrp}</h6>
                                  </div>

                                  <div className="col-md-6">
                                    <label className="text-muted">
                                      Selling Price
                                    </label>
                                    <h6 className="text-success">
                                      ₹ {item.sell_price}
                                    </h6>
                                  </div>

                                </div>

                              </div>

                            </div>

                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center text-muted">
                        No Items Found
                      </div>
                    )}

                  </div>
                </div>

                {/* Payment Details */}

                <div className="card shadow-sm">
                  <div className="card-header bg-warning">
                    <h5 className="mb-0">Payment Details</h5>
                  </div>

                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-bordered align-middle">
                        <tbody>

                          {/* Dealer Purchase History */}
                          <tr className="table-primary">
                            <th colSpan="2" className="text-center">
                              Dealer Purchase History
                            </th>
                          </tr>

                          <tr>
                            <th width="35%">Amount</th>
                            <td>₹ {selectedMachine?.amount || 0}</td>
                          </tr>

                          <tr>
                            <th>Pay ID</th>
                            <td>{selectedMachine?.pay_id || "-"}</td>
                          </tr>

                          <tr>
                            <th>Payment Mode</th>
                            <td>{selectedMachine?.pay_mode || "-"}</td>
                          </tr>

                          <tr>
                            <th>Purchase Status</th>
                            <td>{selectedMachine?.enq_pay_status || "-"}</td>
                          </tr>

                          <tr>
                            <th>Purchase Date</th>
                            <td>{formatDate(selectedMachine?.enq_pur_date || "-")}</td>
                          </tr>

                          {/* Customer Advance Payment */}
                          <tr className="table-success">
                            <th colSpan="2" className="text-center">
                              Customer Advance Payment Details
                            </th>
                          </tr>

                          <tr>
                            <th>Advance Amount</th>
                            <td>₹ {selectedMachine?.advance_amt || 0}</td>
                          </tr>

                          <tr>
                            <th>Advance Payment ID</th>
                            <td>{selectedMachine?.advance_pay_id || "-"}</td>
                          </tr>

                          <tr>
                            <th>Advance Payment Mode</th>
                            <td>{selectedMachine?.advance_mode || "-"}</td>
                          </tr>

                          <tr>
                            <th>Advance Date</th>
                            <td>{formatDate(selectedMachine?.advance_date || "-")}</td>
                          </tr>

                          <tr>
                            <th>Advance Payment Status</th>
                            <td>{selectedMachine?.advance_pay_status || "-"}</td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>


              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowMachineModal(false);
                    setSelectedMachine(null);
                  }}
                >
                  Close
                </button>
              </div>

            </div>
          </div>
        </div>
      )}



      {showCloseModal && (
        <div
          className="modal d-block"
          style={{
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content border-0 shadow-lg"
              style={{
                borderRadius: "18px",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <div
                className="text-center py-4"
                style={{
                  background: "linear-gradient(135deg,#dc3545,#b91c1c)",
                }}
              >
                <div
                  className="mx-auto d-flex align-items-center justify-content-center"
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.2)",
                  }}
                >

                  <CgDanger style={{ fontSize: "34px", color: 'white' }} />
                </div>

                <h4 className="text-white fw-bold mt-3 mb-0">
                  Close Enquiry
                </h4>
              </div>

              {/* Body */}
              <div className="p-4 text-center">
                <h5 className="fw-bold mb-2">
                  {selectedData?.name}
                </h5>

                <p className="text-muted mb-4">
                  Are you sure you want to <strong>close this enquiry</strong>?
                  <br />
                  This action will mark the enquiry as closed and it will no longer
                  be available .
                </p>

                <div
                  className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
                  style={{
                    background: "#fde8e8",
                  }}
                >
                  <span className="me-2 fw-semibold text-dark">
                    Current Status
                  </span>

                  <span className="badge bg-success">
                    {selectedData?.enquire_status}
                  </span>
                </div>
              </div>

              <div className="mb-3 px-4">
                <label className="form-label fw-semibold">Enter OTP</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => {
                    setOtp(e.target.value);
                    setOtpError("");
                  }}
                />

                {otpError && (
                  <small className="text-danger">{otpError}</small>
                )}
              </div>

              {/* Footer */}
              <div className="px-4 pb-4 d-flex gap-3">
                <button
                  className="btn btn-light border w-50"
                  style={{ borderRadius: "10px" }}
                  onClick={() => setShowCloseModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-danger w-50"
                  style={{
                    borderRadius: "10px",
                    fontWeight: 600,
                  }}
                  onClick={handleCloseEnquiry}
                >
                  <i className="bi bi-lock-fill me-2"></i>
                  Yes, Close Enquiry
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {showRefundModal && (
        <div
          className="modal d-block"
          style={{
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content border-0 shadow-lg"
              style={{
                borderRadius: "18px",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <div
                className="position-relative text-center py-4"
                style={{
                  background: "linear-gradient(135deg,#dc3545,#ef4444)",
                }}
              >

                <button
                  className="btn btn-sm btn-light position-absolute"
                  style={{
                    top: 15,
                    right: 15,
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                  }}
                  onClick={() => {
                    setShowRefundModal(false);
                    setShowCancelRefund(false);
                    setRemark("");
                  }}
                >
                  ✕
                </button>

                <div
                  className="mx-auto d-flex align-items-center justify-content-center"
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,.2)",
                  }}
                >
                  <FaUserCheck size={34} color="#fff" />
                </div>

                <h4 className="text-white fw-bold mt-3">
                  Confirm Refund
                </h4>
              </div>

              {/* Body */}
              <div className="p-4">
                <div className="text-center mb-4">
                  <h4 className="fw-bold mb-1">{selectedDriver?.cust_name}</h4>

                </div>

                <div className="card border-0 shadow-sm">
                  <div className="card-body">

                    <div className="row mb-3">
                      <div className="col-5 fw-semibold text-muted">
                        Account No
                      </div>
                      <div className="col-7">
                        {selectedDriver?.cust_acc}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-5 fw-semibold text-muted">
                        Verification
                      </div>
                      <div className="col-7">
                        <span
                          className={`badge ${selectedDriver?.cust_verify == 1
                              ? "bg-success"
                              : "bg-danger"
                            }`}
                        >
                          {selectedDriver?.cust_verify == 1
                            ? "Verified"
                            : "Not Verified"}
                        </span>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-5 fw-semibold text-muted">
                        Refund Amount
                      </div>
                      <div className="col-7 fw-bold text-success">
                        ₹
                        {(
                          Number(selectedDriver?.advance_amt || 0) -
                          Number(selectedDriver?.platform_fee || 0)
                        ).toFixed(2)}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-5 fw-semibold text-muted">
                        Current Status
                      </div>
                      <div className="col-7">
                        <span className="badge bg-warning text-dark">
                          {selectedDriver?.enquire_status}
                        </span>
                      </div>
                    </div>

                  </div>
                </div>

                <p className="text-center text-muted mt-4 mb-0">
                  Are you sure you want to refund this booking?
                </p>

                {showCancelRefund && (
                  <div className="mt-4">
                    <label className="form-label fw-semibold">
                      Cancellation Remark
                    </label>

                    <textarea
                      className="form-control"
                      rows={4}
                      placeholder="Enter cancellation remark..."
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="px-4 pb-4">
                {!showCancelRefund ? (
                  <div className="d-flex gap-3">
                    <button
                      className="btn btn-danger w-50"
                      onClick={handleRefund}
                    >
                      Confirm Refund
                    </button>

                    <button
                      className="btn btn-outline-secondary w-50"
                      onClick={() => setShowCancelRefund(true)}
                    >
                      Cancel Refund
                    </button>
                  </div>
                ) : (
                  <div className="d-flex gap-3">
                    <button
                      className="btn btn-secondary w-50"
                      onClick={() => {
                        setShowCancelRefund(false);
                        setRemark("");
                      }}
                    >
                      Back
                    </button>

                    <button
                      className="btn btn-danger w-50"
                      onClick={handleCancelRefund}
                    >
                      Cancel This Refund
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}



      {showDeleteModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={() => {
              setShowDeleteModal(false);
              setSelectedDelete(null);
            }}
          ></div>

          <div className="modal fade show d-block">
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content border-0 shadow-lg"
                style={{ borderRadius: "16px" }}
              >

                <div className="modal-header bg-danger text-white">
                  <h5 className="modal-title fw-bold">
                    🗑 Delete Enquiry
                  </h5>

                  <button
                    className="btn-close btn-close-white"
                    onClick={() => setShowDeleteModal(false)}
                  ></button>
                </div>


                <div className="modal-body text-center py-4">

                  <div style={{ fontSize: "60px" }}>⚠️</div>

                  <h5 className="mt-3 fw-bold">
                    Are you sure?
                  </h5>

                  <p className="text-muted mb-0">
                    You are about to permanently delete this enquiry.
                  </p>

                  <h6 className="fw-bold text-dark mt-2">
                    {selectedDelete?.cust_name}
                  </h6>

                  <p className="text-danger fw-semibold mt-2">
                    This action cannot be undone.
                  </p>

                </div>


                <div className="modal-footer border-0 justify-content-center">

                  <button
                    className="btn btn-outline-secondary px-4"
                    onClick={() => {
                      setShowDeleteModal(false);
                      setSelectedDelete(null);
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-danger px-4"
                    onClick={handleDeleteEnquiry}
                  >
                    🗑 Delete
                  </button>

                </div>

              </div>
            </div>
          </div>
        </>
      )}


      {showExchangeModal && (

        <div
          className="modal d-block"
          style={{
            background: "rgba(0,0,0,.55)",
            backdropFilter: "blur(4px)",
            zIndex: 9999
          }}
        >

          <div className="modal-dialog modal-dialog-centered">

            <div className="modal-content border-0 shadow-lg"
              style={{
                borderRadius: "18px",
                overflow: "hidden"
              }}>


              {/* Header */}

              <div
                className="text-center py-4"
                style={{
                  background: "linear-gradient(135deg,#0d6efd,#2563eb)"
                }}
              >

                <button
                  className="btn btn-light position-absolute"
                  style={{
                    right: 15,
                    top: 15,
                    borderRadius: "50%"
                  }}
                  onClick={() => {
                    setShowExchangeModal(false);
                    setShowCancelExchange(false);
                    setExchangeRemark("");

                     setShowExchangeOtp(false);
  setExchangeOtp("");
  setExchangeOtpError("");
                  }}
                >
                  ✕
                </button>


                <h4 className="text-white fw-bold mt-3">
                  Confirm Exchange
                </h4>


              </div>



              {/* Body */}

              <div className="p-4">


                <h4 className="text-center fw-bold">
                  {selectedExchange?.dealer?.cust_name}
                </h4>


                <div className="card shadow-sm border-0 mt-3">

                  <div className="card-body">


                    <div className="row mb-3">

                      <div className="col-5 text-muted fw-semibold">
                        Request Type
                      </div>

                      <div className="col-7">
                        {selectedExchange?.request?.req_type}
                      </div>

                    </div>



                    <div className="row mb-3">

                      <div className="col-5 text-muted fw-semibold">
                        Current Status
                      </div>

                      <div className="col-7">

                        <span className="badge bg-warning text-dark">

                          {selectedExchange?.request?.status}

                        </span>

                      </div>

                    </div>


                  </div>

                </div>



                {/* <p className="text-center text-muted mt-4">

                  Are you sure you want to complete this exchange?

                </p> */}
{!showExchangeOtp ? (

<p className="text-center text-muted mt-4">
  Are you sure you want to complete this exchange?
</p>

) : (

<div className="mt-4">

<label className="form-label fw-semibold">
  Enter OTP
</label>

<input
  type="text"
  className="form-control"
  placeholder="Enter customer OTP"
  value={exchangeOtp}
  onChange={(e)=>{
    setExchangeOtp(e.target.value);
    setExchangeOtpError("");
  }}
/>

{exchangeOtpError && (
  <small className="text-danger">
    {exchangeOtpError}
  </small>
)}

</div>

)}



                {showCancelExchange && (

                  <div className="mt-3">

                    <label className="form-label fw-semibold">
                      Cancellation Remark
                    </label>


                    <textarea
                      className="form-control"
                      rows="4"
                      placeholder="Enter cancellation remark..."
                      value={exchangeRemark}
                      onChange={(e) => setExchangeRemark(e.target.value)}
                    />


                  </div>

                )}


              </div>



              {/* Footer */}

              <div className="px-4 pb-4">


                {!showCancelExchange ? (

                  <div className="d-flex gap-3">


                    {/* <button
                      className="btn btn-success w-50"
                      onClick={handleExchangeComplete}
                    >
                      Complete Exchange
                    </button> */}
<button
  className="btn btn-success w-50"
  onClick={() => {

    if(!showExchangeOtp){
      setShowExchangeOtp(true);
      return;
    }

    verifyExchangeOtp();

  }}
>
  {showExchangeOtp ? "Verify OTP" : "Complete Exchange"}
</button>


                    <button
                      className="btn btn-danger w-50"
                      onClick={() => setShowCancelExchange(true)}
                    >
                      Cancel Exchange
                    </button>


                  </div>


                ) : (


                  <div className="d-flex gap-3">


                    <button
                      className="btn btn-secondary w-50"
                      onClick={() => {
                        setShowCancelExchange(false);
                        setExchangeRemark("");
                      }}
                    >
                      Back
                    </button>


                    <button
                      className="btn btn-danger w-50"
                      onClick={handleExchangeCancel}
                    >
                      Confirm Cancel
                    </button>


                  </div>


                )}


              </div>



            </div>

          </div>

        </div>

      )}


      {showReturnModal && (
        <div
          className="modal d-block"
          style={{
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content border-0 shadow-lg"
              style={{
                borderRadius: "18px",
                overflow: "hidden",
              }}
            >

              {/* Header */}
              <div
                className="position-relative text-center py-4"
                style={{
                  background: "linear-gradient(135deg,#f59e0b,#f97316)",
                }}
              >

                <button
                  className="btn btn-sm btn-light position-absolute"
                  style={{
                    top: 15,
                    right: 15,
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                  }}
                  onClick={()=>{
 setShowReturnModal(false);
 setShowCancelReturn(false);
 setReturnRemark("");
 setShowReturnOtp(false);
 setReturnOtp("");
 setOtpError("");
}}

                >
                  ✕
                </button>


                <div
                
                >
                
                  <PiKeyReturnFill  className="mx-auto d-flex align-items-center justify-content-center"
                  style={{
                    width: "70px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,.2)",
                  }} />
                </div>


                <h4 className="text-white fw-bold mt-3">
                  Confirm Return
                </h4>

              </div>


              {/* Body */}
              <div className="p-4">


                <div className="text-center mb-1">

                  <h4 className="fw-bold mb-1">
                    {selectedReturn?.dealer?.cust_name}
                  </h4>

                  <small className="text-muted">
                    {selectedReturn?.dealer?.cust_mobile}
                  </small>

                </div>



                <div className="card border-1 shadow-lg">

                  <div className="card-body">


                    <div className="row mb-3">

                      <div className="col-5 fw-semibold text-muted">
                        Request Type
                      </div>

                      <div className="col-7">
                        Return
                      </div>

                    </div>



                    <div className="row mb-3">

                      <div className="col-5 fw-semibold text-muted">
                        Current Status
                      </div>

                      <div className="col-7">

                        <span className="badge bg-warning text-dark">
                          {selectedReturn?.request?.status}
                        </span>

                      </div>

                    </div>



                    <div className="row">

                      <div className="col-5 fw-semibold text-muted">
                        Added On
                      </div>

                      <div className="col-7">
                        {selectedReturn?.request?.added_on}
                      </div>

                    </div>
                    <div className="row mt-3">

  <div className="col-5 fw-semibold text-muted">
    Amount
  </div>

  <div className="col-7 fw-bold text-success">
    ₹ {returnAmount.toFixed(2)}
  </div>

</div>



                  </div>

                </div>



                {/* <p className="text-center text-muted mt-4 mb-0">

                  Are you sure you want to complete this return item?

                </p> */}
{!showReturnOtp ? (

<p className="text-center text-muted mt-4 mb-0">
  Are you sure you want to complete this return item?
</p>

) : (

<div className="mt-4">

<label className="form-label fw-semibold">
  Enter OTP
</label>

<input
  type="text"
  className="form-control"
  placeholder="Enter customer OTP"
  value={returnOtp}
  onChange={(e)=>{
    setReturnOtp(e.target.value);
    setOtpError("");
  }}
/>


{otpError && (
  <small className="text-danger">
    {otpError}
  </small>
)}

</div>

)}



                {showCancelReturn && (

                  <div className="mt-4">

                    <label className="form-label fw-semibold">
                      Cancellation Remark
                    </label>


                    <textarea
                      className="form-control"
                      rows={4}
                      placeholder="Enter return cancellation remark..."
                      value={returnRemark}
                      onChange={(e) => setReturnRemark(e.target.value)}
                    />

                  </div>

                )}


              </div>



              {/* Footer */}
              <div className="px-4 pb-4">


                {!showCancelReturn ? (

                  <div className="d-flex gap-3">


                    {/* <button
                      className="btn btn-success w-50"
                      onClick={handleReturnComplete}
                    >
                      Complete Return
                    </button> */}
<button
 className="btn btn-success w-50"
 onClick={()=>{
   
   if(!showReturnOtp){
      setShowReturnOtp(true);
      return;
   }

   verifyReturnOtp();

 }}
>
 {showReturnOtp ? "Verify OTP" : "Complete Return"}
</button>



                    <button
                      className="btn btn-danger w-50"
                      onClick={() => {
                        setShowCancelReturn(true);
                      }}
                    >
                      Cancel Return
                    </button>


                  </div>


                ) : (


                  <div className="d-flex gap-3">


                    <button
                      className="btn btn-secondary w-50"
                      onClick={() => {
                        setShowCancelReturn(false);
                        setReturnRemark("");
                      }}
                    >
                      Back
                    </button>



                    <button
                      className="btn btn-danger w-50"
                      onClick={handleReturnCancel}
                    >
                      Confirm Cancel
                    </button>


                  </div>


                )}


              </div>


            </div>
          </div>
        </div>
      )}

      {showReturnDetailModal && (

        <div
          className="modal d-block"
          style={{
            background: "rgba(0,0,0,0.55)",
            backdropFilter: "blur(4px)",
            zIndex: 9999
          }}
        >

          <div className="modal-dialog  modal-dialog-centered">

            <div
              className="modal-content border-0 shadow-lg"
              style={{
                borderRadius: "18px",
                overflow: "hidden"
              }}
            >


              {/* Header */}

              <div
                className="text-center py-4 position-relative"
                style={{
                  background: "linear-gradient(135deg,#2563eb,#1d4ed8)"
                }}
              >

                <button
                  className="btn btn-light position-absolute"
                  style={{
                    right: "15px",
                    top: "15px",
                    borderRadius: "50%"
                  }}
                  onClick={() => {
                    setShowReturnDetailModal(false);
                    setSelectedReturnDetail(null);
                  }}
                >
                  ✕
                </button>


                <h4 className="text-white fw-bold">
                  Return Details
                </h4>
              </div>
              {/* Body */}

              <div className="p-2">

                <div className="text-center mb-1">

                  <h4 className="fw-bold">
                    {selectedReturnDetail?.dealer?.cust_name}
                  </h4>

                  <p className="text-muted mb-0">
                    {selectedReturnDetail?.dealer?.cust_mobile}
                  </p>

                </div>



                <div className="card border-1 shadow-lg">

                  <div className="card-body">


                    <div className="row mb-3">

                      <div className="col-md-4 fw-semibold text-muted">
                        Request Type
                      </div>

                      <div className="col-md-8">
                        {selectedReturnDetail?.request?.req_type}
                      </div>

                    </div>



                    <div className="row mb-3">

                      <div className="col-md-4 fw-semibold text-muted">
                        Status
                      </div>

                      <div className="col-md-8">

                        <span
                          className={`badge ${selectedReturnDetail?.request?.status === "Return Completed"
                              ? "bg-success"
                              : selectedReturnDetail?.request?.status === "Return Cancelled"
                                ? "bg-danger"
                                : "bg-warning text-dark"
                            }`}
                        >

                          {selectedReturnDetail?.request?.status}

                        </span>

                      </div>

                    </div>



                    <div className="row mb-3">

                      <div className="col-md-4 fw-semibold text-muted">
                        Description
                      </div>

                      <div className="col-md-8">
                        {selectedReturnDetail?.request?.description}
                      </div>

                    </div>



                    <div className="row mb-3">

                      <div className="col-md-4 fw-semibold text-muted">
                        Added On
                      </div>

                      <div className="col-md-8">
                        {formatDate(selectedReturnDetail?.request?.added_on || '-' )}
                      </div>

                    </div>


                  </div>

                </div>



                {/* Items */}

                <h5 className="fw-bold mt-4">
                  Return Items
                </h5>


                <div className="table-responsive">

                  <table className="table table-bordered">

                    <thead className="table-light">

                      <tr>
                        <th>Name</th>
                        <th>Qty</th>
                        <th>Price</th>
                        <th>Discount</th>
                        <th>Final Price</th>
                      </tr>

                    </thead>


                    <tbody>

                      {JSON.parse(
                        selectedReturnDetail?.request?.ret_items || "[]"
                      ).map((item, index) => (

                        <tr key={index}>

                          <td>{item.name}</td>

                          <td>{item.qty}</td>

                          <td>
                            ₹{item.sell_price}
                          </td>
             <td>
                            ₹{item.discount}
                          </td>
                          <td>
                            ₹{item.final_price}
                          </td>

                        </tr>

                      ))}

                    </tbody>

                  </table>

                </div>



                {/* Images */}

                <h5 className="fw-bold mt-4">
                  Uploaded Images
                </h5>


                <div className="row g-3">


                  {selectedReturnDetail?.request?.imgs?.split(",").map((img, index) => (

                    <div
                      className="col-6 col-md-4"
                      key={index}
                    >

                      <img
                        src={`https://api.krimotion.in/aUploads/${img}`}
                        alt="return"
                        className="img-fluid rounded shadow-sm"
                        style={{
                          height: "150px",
                          width: "100%",
                          objectFit: "cover"
                        }}
                      />


                    </div>

                  ))}


                </div>



              </div>


            </div>

          </div>

        </div>

      )}


    </div>
  )
}

export default CustomerSphere
